'use client';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BaseLineCheck2 } from '@/app/components/icons/BaseLineCheck2';
import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { BaseLineDelete } from '@/app/components/icons/BaseLineDelete';
import { cn } from '@/app/utils';

interface ConfirmDeleteProps {
  title?: string;
  onConfirm: () => void;
}

export const ConfirmDelete = ({ title, onConfirm }: ConfirmDeleteProps) => {
  const t = useTranslations('sharedComponent.confirmDelete');

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <BaseLineDelete className="cursor-pointer text-xl" onClick={() => setIsOpen(true)} />

      <div
        className={cn(
          '-translate-y-1/2 pointer-events-none absolute top-1/2 right-0 flex max-w-0 transform items-center gap-4 overflow-hidden rounded-8 bg-system-bg03 py-[7px] pr-2 pl-3 opacity-0 backdrop-blur-[30px] transition-all duration-100 ease-linear',
          isOpen && 'pointer-events-auto max-w-[300px] opacity-100',
        )}
      >
        <div className="whitespace-nowrap font-normal text-system-white text-xs">{title ?? t('title')}</div>
        <div className="flex items-center gap-1 text-system-white">
          <span
            className="cursor-pointer rounded-4 p-1 text-sm hover:bg-system-white10"
            onClick={() => setIsOpen(false)}
          >
            <BaseLineClose />
          </span>
          <span className="h-3 w-[1px] rounded-full bg-system-white10" />
          <span
            className="cursor-pointer rounded-4 p-1 text-sm hover:bg-system-white10"
            onClick={() => {
              onConfirm();
              setIsOpen(false);
            }}
          >
            <BaseLineCheck2 />
          </span>
        </div>
      </div>
    </div>
  );
};
